import React from 'react'
import { Container, Typography } from '@mui/material';

export function Loading() {


    return(
        <>
            <Container maxWidth="xl">
                <Typography
                    variant="body1"
                    p={1}
                >
                    Loading...
                </Typography>
            </Container>
        </>
);
}